import {gql} from "@apollo/client";

export const TRAVEL_GET_CALCULATION_DATA = gql`
	query CalculationData(
		$comparisonId: UUID!
	) {
		calculationData(comparisonId: $comparisonId) {
			comparisonId
			calculationDate
			calculationInput {
				commonTechnical {
					senderId
					sessionId
					transactionReference
					googleAnalyticsId
					accessCode
				}
				policyPolicyDetails {
					refKey
					effectiveDate
					externalSourceName
					productCode
					productDescription
					companyNameDescription
					marketingName
					oneOffCostsAmount
					porCompany
					contractNumber
					paymentTermInMonths
					costsInstallmentAmount
					discountsInstallmentAmount
					grossPremiumInstallment
					insuranceTaxInstallmentAmount
					surchargesInstallmentAmount
					totalInstallmentAmount
					netPremiumInstallment
					expectedAcquisitionCommissionPartnerAmount
					partyPolicyHolders {
						initials
						callName
						prefixes
						surname
						birthDate
						genderOrLegalPersonType
						telephoneNumber
						mobile
						email
						collectionAccountIban
						numberOfChildren
						addresses {
							postalCode
							houseNumber
							houseNumberAddition
						}
						partyChildren {
							initials
							callName
							prefixes
							surname
							birthDate
							genderOrLegalPersonType
						}
						partyPartners {
							initials
							callName
							prefixes
							surname
							birthDate
							genderOrLegalPersonType
						}
						customProperties {
							consumentenbondMember
							consumentenbondMemberEmail
							consumentenbondMemberConditions
							consumentenbondMemberContribution
							consumentenbondNewsletter
							consumentenbondUserId
							consumentenbondUserIsMember
						}
					}
					coverageCancellations {
						productDescription
						petIllnessDeathAdditionallyInsured
						businessTravelAdditionallyInsured
					}
					coverageTravels {
						costsInstallmentAmount
						discountsInstallmentAmount
						grossPremiumInstallment
						surchargesInstallmentAmount
						netPremiumInstallment
						productDescription
						additionalInsuredAmountBicycle
						additionalInsuredAmountLuggage
						adventurousSportsAdditionallyInsured
						alternativeTransportAdditionallyInsured
						assistanceExcludingRoadsideAdditionallyInsured
						businessAgentAdditionallyInsured
						businessTravelAdditionallyInsured
						cancellationAdditionallyInsured
						carrierCoverageCode
						compositeTripAdditionallyInsured
						costsMedicalTreatmentAdditionallyInsured
						coverageAreaCode
						dangerousSportsAdditionallyInsured
						deductibleAmount
						deductibleAmountLuggage
						divingEquipmentAdditionallyInsured
						exceptionalCostsAdditionallyInsured
						extendedStayAdditionallyInsured
						extraAmountDivingEquipmentAdditionallyInsured
						extraAmountGolfEquipmentAdditionallyInsured
						injuryAdditionallyInsured
						insuranceTaxInstallmentAmount
						insuredAmountMoneyChecks
						insuredAmountTravelCancellation
						insuredAmountTravelLuggage
						insuredAmountUnderwaterSportsEquipment
						insuredFamilyComposition
						legalAidAdditionallyInsured
						luggageAdditionallyInsured
						moneyChequesAdditionallyInsured
						numberOfDaysCoverage
						numberOfInsuredCaravans
						numberOfInsuredMotorVehicles
						numberOfInsuredTrailers
						partnerAdditionallyInsured
						refKey
						repatriationCostsAdditionallyInsured
						returnCommissionPercentage
						roadsideAssistanceAdditionallyInsured
						sportsEquipmentAdditionallyInsured
						sumInsured
						totalInstallmentAmount
						underwaterSportsAdditionallyInsured
						winterSportsAdditionallyInsured
					}
					coverageBreakdownAssistances {
						productDescription
					}
					coverageLegalCounsels {
						productDescription
					}
					documents {
						attachmentDescription
						attachmentType
						urlAttachment
					}
					clauses {
						clauseExplanation
						clauseName
						clauseNumber
					}
					conditionConditionDetails {
						conditionNumber
						conditionText
						documents {
							attachmentDescription
							attachmentType
							urlAttachment
						}
					}
					underwritingCompanySpecifics {
						underwritingResult
					}
					underwritingUnderwritingQuestions {
						policyRefusedCancelledLimitedExplanation
						criminalRecordExplanation
						previousLossOrDamageDescription
						numberOfClaims
						financialProblemsExplanation
						fraudulentActivitiesExplanation
						seizureByBailiffExplanation
						inAgreementWithClosingStatement
					}
					customProperties {
						supplierKrn
					}
				}
			}
			calculationOutput {
				commonTechnical {
					senderId
					sessionId
					transactionReference
					googleAnalyticsId
					accessCode
				}
				policyPolicyDetails {
					refKey
					effectiveDate
					externalSourceName
					productCode
					productDescription
					companyNameDescription
					marketingName
					oneOffCostsAmount
					porCompany
					contractNumber
					paymentTermInMonths
					costsInstallmentAmount
					discountsInstallmentAmount
					grossPremiumInstallment
					insuranceTaxInstallmentAmount
					surchargesInstallmentAmount
					totalInstallmentAmount
					netPremiumInstallment
					expectedAcquisitionCommissionPartnerAmount
					partyPolicyHolders {
						initials
						callName
						prefixes
						surname
						birthDate
						genderOrLegalPersonType
						telephoneNumber
						mobile
						email
						collectionAccountIban
						numberOfChildren
						addresses {
							postalCode
							houseNumber
							houseNumberAddition
						}
						partyChildren {
							initials
							callName
							prefixes
							surname
							birthDate
							genderOrLegalPersonType
						}
						partyPartners {
							initials
							callName
							prefixes
							surname
							birthDate
							genderOrLegalPersonType
						}
						customProperties {
							consumentenbondMember
							consumentenbondMemberEmail
							consumentenbondMemberConditions
							consumentenbondMemberContribution
							consumentenbondNewsletter
							consumentenbondUserId
							consumentenbondUserIsMember
						}
					}
					coverageCancellations {
						productDescription
						petIllnessDeathAdditionallyInsured
						businessTravelAdditionallyInsured
					}
					coverageTravels {
						costsInstallmentAmount
						discountsInstallmentAmount
						grossPremiumInstallment
						surchargesInstallmentAmount
						netPremiumInstallment
						productDescription
						additionalInsuredAmountBicycle
						additionalInsuredAmountLuggage
						adventurousSportsAdditionallyInsured
						alternativeTransportAdditionallyInsured
						assistanceExcludingRoadsideAdditionallyInsured
						businessAgentAdditionallyInsured
						businessTravelAdditionallyInsured
						cancellationAdditionallyInsured
						carrierCoverageCode
						compositeTripAdditionallyInsured
						costsMedicalTreatmentAdditionallyInsured
						coverageAreaCode
						dangerousSportsAdditionallyInsured
						deductibleAmount
						deductibleAmountLuggage
						divingEquipmentAdditionallyInsured
						exceptionalCostsAdditionallyInsured
						extendedStayAdditionallyInsured
						extraAmountDivingEquipmentAdditionallyInsured
						extraAmountGolfEquipmentAdditionallyInsured
						injuryAdditionallyInsured
						insuranceTaxInstallmentAmount
						insuredAmountMoneyChecks
						insuredAmountTravelCancellation
						insuredAmountTravelLuggage
						insuredAmountUnderwaterSportsEquipment
						insuredFamilyComposition
						legalAidAdditionallyInsured
						luggageAdditionallyInsured
						moneyChequesAdditionallyInsured
						numberOfDaysCoverage
						numberOfInsuredCaravans
						numberOfInsuredMotorVehicles
						numberOfInsuredTrailers
						partnerAdditionallyInsured
						refKey
						repatriationCostsAdditionallyInsured
						returnCommissionPercentage
						roadsideAssistanceAdditionallyInsured
						sportsEquipmentAdditionallyInsured
						sumInsured
						totalInstallmentAmount
						underwaterSportsAdditionallyInsured
						winterSportsAdditionallyInsured
					}
					coverageBreakdownAssistances {
						productDescription
					}
					coverageLegalCounsels {
						productDescription
					}
					documents {
						attachmentDescription
						attachmentType
						urlAttachment
					}
					clauses {
						clauseExplanation
						clauseName
						clauseNumber
					}
					conditionConditionDetails {
						conditionNumber
						conditionText
						documents {
							attachmentDescription
							attachmentType
							urlAttachment
						}
					}
					underwritingCompanySpecifics {
						underwritingResult
					}
					underwritingUnderwritingQuestions {
						policyRefusedCancelledLimitedExplanation
						criminalRecordExplanation
						previousLossOrDamageDescription
						numberOfClaims
						financialProblemsExplanation
						fraudulentActivitiesExplanation
						seizureByBailiffExplanation
						inAgreementWithClosingStatement
					}
					customProperties {
						supplierKrn
					}
				}
			}
			traces {
				providerTraces {
					krn
					message
					numberOfProducts
				}
				productTraces {
					krn
					supplierName
					totalInstallmentAmount
					underwritingResult
					productStatus
					filteredOut
				}
			}
		}
	}
`;
